import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const leadsAPI = {
  getAll: async (params = {}) => {
    const response = await axios.get(`${API}/leads`, {
      headers: getAuthHeader(),
      params
    });
    return response.data;
  },
  getOne: async (id) => {
    const response = await axios.get(`${API}/leads/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.patch(`${API}/leads/${id}`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

export const socialAPI = {
  getAll: async (status = null) => {
    const params = status ? { status } : {};
    const response = await axios.get(`${API}/social-posts`, {
      headers: getAuthHeader(),
      params
    });
    return response.data;
  },
  getOne: async (id) => {
    const response = await axios.get(`${API}/social-posts/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(`${API}/social-posts`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  generate: async (data) => {
    const response = await axios.post(`${API}/social-posts/generate`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API}/social-posts/${id}`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  approve: async (id) => {
    const response = await axios.post(`${API}/social-posts/${id}/approve`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  reject: async (id) => {
    const response = await axios.post(`${API}/social-posts/${id}/reject`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  regenerateCaption: async (id) => {
    const response = await axios.post(`${API}/social-posts/${id}/regenerate-caption`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  regenerateImage: async (id) => {
    const response = await axios.post(`${API}/social-posts/${id}/regenerate-image`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  delete: async (id) => {
    const response = await axios.delete(`${API}/social-posts/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  getStats: async () => {
    const response = await axios.get(`${API}/social-posts/stats/summary`, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

export const roofAPI = {
  measure: async (address) => {
    const response = await axios.post(`${API}/roof-measurement`, { address }, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  getAll: async () => {
    const response = await axios.get(`${API}/roof-measurements`, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

export const reportsAPI = {
  getWeekly: async () => {
    const response = await axios.get(`${API}/reports/weekly`, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

export const settingsAPI = {
  get: async () => {
    const response = await axios.get(`${API}/settings`, {
      headers: getAuthHeader()
    });
    return response.data;
  },
  update: async (data) => {
    const response = await axios.patch(`${API}/settings`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};